import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './style.scss';
import Icon from '../Icon';

class StepProgressBarV2 extends Component {
  static propTypes = {
    steps: PropTypes.array,
    currentStep: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func
  };

  static defaultProps = {
    currentStep: 0,
    steps: []
  };

  @bind
  handleClick(index) {
    if (this.props.onClick) {
      this.props.onClick(index);
    }
  }

  renderSteps() {
    const { currentStep, steps } = this.props;
    const currentStepIndex = steps.findIndex(s => s.name === currentStep);

    return steps.map((step, index) => {
      const stepCN = cn('step-progress-bar-v2__step', {
        'step-progress-bar-v2__step--completed': index <= currentStepIndex,
        'step-progress-bar-v2__step--current': index === currentStepIndex,
        'step-progress-bar-v2__step--clickable': Boolean(this.props.onClick)
      });

      return (
        <React.Fragment key={index}>
          {index > 0 && <div className="step-progress-bar-v2__line" />}

          <div className={stepCN} data-cy={`step-${index}`}>
            <div className="step-progress-bar-v2__step-index" onClick={() => this.handleClick(index)}>
              {index < currentStepIndex ? <Icon name="checkmark" size={24} /> : index + 1}
            </div>

            <div className="step-progress-bar-v2__step-title">{step.label}</div>
          </div>
        </React.Fragment>
      );
    });
  }

  render() {
    const { className, steps } = this.props;
    const barCN = cn('step-progress-bar-v2', className);

    return (
      <div className={barCN} style={{ maxWidth: `${steps.length * 187.5}px` }}>
        {this.renderSteps()}
      </div>
    );
  }
}

export default StepProgressBarV2;
